import * as React from "react"
import styled from "styled-components"
import { Container } from "./UI"
import ProgressiveImage from "react-progressive-bg-image"
import { DEFAULT_SPACE_PICTURE } from "src/config/constants"
import { LoadingOutlined } from "@ant-design/icons"
import { Spin } from "antd"
const HeroWrapper = styled(ProgressiveImage)`
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: cover;
    background-position: center center;
    background-image:url('${props => props.src}');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    position: relative;
    @media (max-width: 768px) {
      background-position: left center;
    }
`

const Heading = styled.h2`
  font-family: "Comfortaa", cursive !important;
  font-size: 2.625rem;
  font-weight: 300;
  line-height: 1.4;
  text-transform: uppercase;
  color: #ffffff;
  z-index: 1;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

const TextContainer = styled(Container as any)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  @media (max-width: 768px) {
    width: 90%;
  }
`
interface props {
  heading: string
  url: string
}

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

const Hero = ({ heading = "", url = DEFAULT_SPACE_PICTURE }: props) => {
  return (
    <HeroWrapper src={url} placeholder={<Spin indicator={antIcon} />}>
      <TextContainer>
        <Heading></Heading>
      </TextContainer>
    </HeroWrapper>
  )
}

export default Hero
